module.exports = __webpack_public_path__ + "static/Abbotsford5-de4e36ced660c39174ce78170b5a28ce.jpg";